function Description() {
  return (
    <p className="description">
      🔴 I made this quiz myself, the quiz certificate is not official but I
      made it myself
    </p>
  );
}

export default Description;
